/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TextField = (function () {

    function TextField () {

        Monet.UI.Fields.Base.apply(this, arguments);

        this.createBaseStructure();

        this.input = null;
        this.value = "";

        var baseElement = null;

        this.createElement = function () {

            if (!baseElement) {
                this.input = document.createElement('input');
                this.rootEl.className += ' textField';
                this.input.type = 'text';
                this.input.autocomplete = 'off';

                baseElement = this.input;

                if (this.maxSize) {
                    this.input.maxLength = this.maxSize;
                }

                this.rootEl.appendChild(this.input);
            }

        };

        this.getValue = function () {
            if (this.input) {
                this.value = this.input.value;
            }
            return this.value;
        };

        this.setValue = function (value) {
            if (value || value === '' || value === 0) {
                this.value = value;
            }

            this.setInputValue();
        };

        this.setInputValue = function () {

            if (this.input) {
                this.input.value = new Monet.Format.TEXT(this.value).getValue();
            }
        };

        this.render = function () {

            this.createElement();
            this.setInputValue();
            return this.rootEl;

        };

        this.setPlaceHolder = function (text) {

            if (this.input) {
                this.input.placeholder = text;
            } else {
                var error = new Monet.Exception.ReturnError(
                    this, 'Monet.UI.Fields.TextField: setPlaceHolder: this.input is null'
                );

                error.console();
            }

        };

    }

    return TextField;

}());